var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-unit-detail"},[_c('el-row',[_c('el-col',[(_vm.unitId === 0)?_c('h2',[_vm._v("ユニット 新規登録")]):_c('h2',[_vm._v("ユニット 編集")])])],1),_c('Tools02UnitDetailUnitEditor',{attrs:{"unitId":_vm.unitId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }